(function () {
  appointmentList.$inject = ["API_URL", "$http", "$rootScope", "$location"];
  angular.module('calendarApp').directive('appointmentList', appointmentList);

  function appointmentList(API_URL, $http, $rootScope, $location) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/appointment-list.html',
      scope: {
        appointments: '=',
        hideDelete: '=?',
        waitlist: '=?',
        // Don't show waitlist on review page, etc.
        chooseWaitlist: '=?',
        onDelete: '=?',
        showPayment: '=?'
      },
      link: function link(scope, elem, attrs) {
        scope.timeSettings = smooth.timeSettings;
        scope.hasResource = scope.appointments.find(function (appt) {
          return !!appt.resourceid;
        });
        scope.$watch('appointments', function () {
          if (!scope.appointments || !scope.appointments.length) {
            return;
          }

          scope.appointments.sort(function (app1, app2) {
            return app1.start > app2.start;
          });
          scope.showZoom = !!scope.appointments.find(function (appt) {
            return appt.zoom && appt.zoom.join_url;
          });
        });

        scope.doWaitlist = function (appointment) {
          scope.chooseWaitlist(appointment);
        };
      }
    };
  }
})();